<div
  #runnerRef [hidden]="selectedRace?.RaceStatus === 3" class="runner-section web-view"
>

  <!-- option headers -->
  <div class="basic-info-stats-replays">
    <div
      (click)="showBasic()"
      [ngClass]="{'tw-bg-[#557DAC]': controller.basic}"
      class="
        tw-w-[93px]
        tw-inline-block
        tw-cursor-pointer
        tw-bg-[#19385D]
        tw-text-center
        tw-text-[16px]
        tw-text-[#FFFFFF]
        tw-rounded-tr-[4px]
        tw-rounded-tl-[4px]
        tw-mr-[3px]
        tw-p-[2px]
      "
    >
      {{ 'wager.basic' | translate: 'Basic' }}
    </div>
    <div
      (click)="showInfo()"
      [ngClass]="{'tw-bg-[#557DAC]': controller.info}"
      class="
        tw-w-[93px]
        tw-inline-block
        tw-cursor-pointer
        tw-bg-[#19385D]
        tw-text-center
        tw-text-[16px]
        tw-text-[#FFFFFF]
        tw-rounded-tr-[4px]
        tw-rounded-tl-[4px]
        tw-mr-[3px]
        tw-p-[2px]
      "
    >
      {{ 'wager.info' | translate: 'Info' }}
    </div>
    <!-- <div
      (click)="showStats()"
      [ngClass]="{'tw-bg-[#557DAC]': controller.stats}"
      class="
        tw-w-[93px]
        tw-inline-block
        tw-cursor-pointer
        tw-bg-[#19385D]
        tw-text-center
        tw-text-[16px]
        tw-text-[#FFFFFF]
        tw-rounded-tr-[4px]
        tw-rounded-tl-[4px]
        tw-mr-[3px]
        tw-p-[2px]
      "
    >
      Stats
    </div> -->
    <div
      (click)="showReplays()"
      [ngClass]="{'tw-bg-[#FF6F6E]': controller.replays}"
      class="
        show-replays-button
        tw-left-[8px]
        tw-w-[113px]
        tw-inline-block
        tw-cursor-pointer
        tw-bg-[#19385D]
        tw-text-center
        tw-text-[16px]
        tw-text-[#FFFFFF]
        tw-rounded-tr-[4px]
        tw-rounded-tl-[4px]
        tw-mr-[3px]
        tw-p-[2px]
      "
    >
      <img
        [ngClass]="{'tw-hidden': !controller.replays}"
        class="
          tw-relative
          tw-left-[9px]
          tw-w-[26px]
          tw-h-[24px]
          tw-float-left
        "
        src="assets/images/wager/replays_icon.png"
        alt="{{ 'ui.wager.replays.icon' | translate: 'replays icon' }}"
      >
      {{ 'STABLE_SYSTEM.REPLAY' | translate: 'Replays' }}
    </div>
  </div>

  <!-- Selection-change skeleton — swaps in for the runner table
       for ~600 ms while the store swaps runners / odds. -->
  <div
    *ngIf="showSelectionSkeleton"
    class="runner-skeleton tw-w-full tw-h-[600px] tw-p-[10px] tw-bg-[#EDF1F5] tw-rounded-b-[5px]"
    aria-hidden="true"
    data-cy="runner-selection-skeleton"
  >
    <div class="runner-skeleton__bar tw-h-[36px] tw-w-full tw-mb-[10px]"></div>
    <div class="runner-skeleton__bar tw-h-[46px] tw-w-full tw-mb-[8px]"></div>
    <div class="runner-skeleton__bar tw-h-[46px] tw-w-full tw-mb-[8px]"></div>
    <div class="runner-skeleton__bar tw-h-[46px] tw-w-full tw-mb-[8px]"></div>
    <div class="runner-skeleton__bar tw-h-[46px] tw-w-full tw-mb-[8px]"></div>
    <div class="runner-skeleton__bar tw-h-[46px] tw-w-full tw-mb-[8px]"></div>
    <div class="runner-skeleton__bar tw-h-[46px] tw-w-full tw-mb-[8px]"></div>
    <div class="runner-skeleton__bar tw-h-[46px] tw-w-[85%] tw-mb-[8px]"></div>
  </div>

  <div
    *ngIf="!showSelectionSkeleton"
    #wagingSectionTemplateRef
    class="waging-section tw-flex tw-h-[600px] tw-overflow-y-auto"
  >

    <!-- Left side -->
    <div class="runner-container" data-cy="runner-container">

      <!-- Runner table -->
      <div
        class="
          current-races
          tw-bg-[#EDF1F5]
          tw-w-[100%]
          tw-rounded-br-[5px]
          tw-rounded-bl-[5px]
        "
        data-cy="runner-table"
      >

        <!-- Header: flex nowrap so columns shrink with the body rows instead of wrapping (keeps Payout aligned) -->
        <div class="head-runner tw-flex tw-flex-nowrap tw-items-center tw-w-full tw-bg-[#C7C7C6] tw-py-[10px] tw-pl-[10px]">
          <span class="tw-w-[278px] tw-font-bold">{{ 'generic.runner' | translate: 'Runner' }}</span>
          <span class="tw-w-[51px] tw-text-center tw-font-bold">{{ 'generic.elo' | translate: 'Elo' }}</span>
          <span class="tw-w-[51px] tw-uppercase tw-text-center tw-font-bold">{{ 'generic.ml' | translate: 'ML' }}</span>
          <span class="tw-w-[51px] tw-text-center tw-font-bold">{{ 'generic.odds' | translate: 'Odds' }}</span>
          <span class="tw-w-[110px] tw-font-bold tw-invisible">.</span>

          @if (!dblPkArray) {
            @for (
              leg of convertLegRange(
                selectedPool?.Legs,
                selectedPool?.PoolRaces,
                selectedPool?.PoolId,
                selectedPool,
                selectedModifier
              );
              track $index
            ) {
              <span
                class="
                  place
                  tw-w-[51px]
                  tw-text-center
                  tw-font-bold
                "
                data-cy="wager-legs"
              >
                {{ leg | ordinals }}
              </span>
            }
          }

          @if (dblPkArray) {
            @for (item of dblPkArray; track trackByRaceId($index, item)) {
              @if (item.RaceId) {
                <span
                  (click)="showCurrentInfoByRace(item.RaceId, $index)"
                  (mouseenter)="showCurrentInfoByRace(item.RaceId, $index)"
                  [class.active]="item.RaceId === showCurrentInfo"
                  id="race"
                  class="
                    place
                    tw-w-[51px]
                    tw-text-center
                    tw-font-bold
                    tw-cursor-pointer
                  "
                  data-cy="wager-legs"
                >
                  R{{ item.RaceId }}
                </span>
              }
            }
          }

          <!-- $1 Pays column sits after the bet legs (hidden for GSL/DBL/PK) -->
          @if (!hidePays) {
            <span class="tw-w-[60px] tw-text-center tw-font-bold">{{ 'ui.wager.1.pays' | translate: '$1 Pays' }}</span>
            <!-- Stake + Payout only for single-leg, single-race pools -->
            @if (!hideStake) {
              <span class="tw-w-[60px] tw-text-center tw-font-bold">{{ 'generic.stake' | translate: 'Stake' }}</span>
              <span class="tw-w-[60px] tw-text-center tw-font-bold">{{ 'generic.payout' | translate: 'Payout' }}</span>
            }
          }
        </div>

        <!-- BODY: single-race pools (NOT Pick/DBL) -->
        @if (!dblPkArray) {
          <div class="table-runner runners-section">
            <div class="content-runner">

              @if (!selectedRace?.Runners?.[0]?.Entries) {
                <p class="tw-p-2">
                  {{ 'ui.wager.no.entries.available' | translate: 'No Entries Available' }}
                </p>
              }

              @if (selectedRace?.Runners?.[0]?.Entries) {

                @for (
                  runner of selectedRace.Runners;
                  let indexRunner = $index;
                  track trackByRunners(indexRunner, runner)
                ) {
                  <div
                    class="
                      !tw-block
                      runner-info
                      runner-id-{{runner.RunnerId}}
                    "
                    [attr.data-cy]="'runner-info-' + runner.RunnerId"
                    amwager3LegHeight
                    [amwager3LegHeightRunnerId]="runner.RunnerId"
                    [amwager3LegHeightEntries]="runner.Entries"
                    data-cy="runner-row"
                  >

                    @for (
                      runnerEntry of runner?.Entries;
                      let i = $index;
                      track trackByEntries(i, runnerEntry)
                    ) {
                      <div
                        #currentEntries
                        class="
                          runner-group
                          runner-ui-{{runner.RunnerId}}-{{i+1}}
                        "
                        [attr.data-cy]="'runner-entry-' + i"
                      >
                        <div
                          [ngClass]="{'tw-border-t-[1px]': runnerWithReplays.length > 0}"
                          class="
                            tw-w-full
                            tw-flex
                            tw-border-[#7C8FCC]
                            tw-border-r-[1px]
                            tw-border-l-[1px]
                            tw-border-b-[1px]
                            tw-pl-[10px]
                          "
                        >
                          <div class="runner tw-w-[278px] tw-relative tw-py-[5px]">
                            <div class="tw-items-center">
                              <p class="tw-inline-block">
                                <span
                                  class="entry-name"
                                  [class.tw-line-through]="runnerEntry?.Scratch"
                                  [attr.data-cy]="'runner-name-' + runner.RunnerId + '-' + i"
                                >
                                  {{ runnerEntry.Name }}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div class="elo tw-w-[51px] tw-py-[5px]">
                            <p
                              class="tw-text-center tw-italic"
                              [attr.data-cy]="'runner-elo-' + runner.RunnerId + '-' + i"
                            >
                              {{
                                runnerEntry?.Scratch
                                  ? '-'
                                  : getRunnerElo(
                                      selectedRace?.RaceId,
                                      runner.RunnerId,
                                      runnerEntry?.EntryId
                                    )
                              }}
                            </p>
                          </div>
                          <div class="ml tw-w-[51px] tw-py-[5px]">
                            <p
                              class="tw-text-center"
                              [attr.data-cy]="'runner-ml-' + runner.RunnerId + '-' + i"
                            >
                              {{
                                (runnerEntry?.Scratch) ?
                                  '-'
                                :
                                  runner.Odds || '-'
                              }}
                            </p>
                          </div>
                          <div class="odds tw-w-[51px] tw-py-[5px]">
                            <p
                              class="tw-text-center"
                              [class.tw-line-through]="runnerEntry?.Scratch"
                              [attr.data-cy]="'runner-odds-' + runner.RunnerId + '-' + i"
                            >
                              {{
                                (runnerEntry?.Scratch) ?
                                  'SCR'
                                    :
                                  !selectedRace.Current ?
                                    '-'
                                      :
                                    ((matrix || null) | matrixData: indexRunner: 'odd') || '-'
                              }}
                            </p>
                          </div>
                          <div
                            class="pos tw-w-[110px] tw-flex"
                            [attr.data-cy]="'runner-position-' + runner.RunnerId + '-' + i"
                          >
                            <div
                              class="runner-chart tw-w-[65%]"
                              [attr.data-runner-id]="runner.RunnerId"
                            ></div>
                            <div
                              class="
                                tw-w-[35%]
                                tw-h-full
                                tw-relative
                                tw-text-center
                                tw-self-center
                                tw-items-center
                                tw-px-[5px]
                                {{
                                  (
                                    selectedEvent?.ToteResponse?.EventDetail?.TrackType
                                    | getTrackType: true
                                  ) +'-'+ runner?.RunnerId
                                }}
                              "
                            >
                              <div class="tw-h-full tw-content-center">
                                {{
                                  i > 0 ? runner.RunnerId + runnerEntry?.EntryId : runner.RunnerId
                                }}
                              </div>
                              <!-- Post position badge, only when it differs from the saddle number -->
                              @if ((runnerEntry?.Position | toNumber) !== runner.RunnerId) {
                                <span
                                  class="tw-text-[9px] tw-absolute tw-top-[2px] tw-right-[3px]"
                                  [attr.data-cy]="'runner-post-' + runner.RunnerId + '-' + i"
                                >
                                  {{ runnerEntry?.Position }}
                                </span>
                              }
                            </div>
                          </div>

                          <div
                            [ngClass]="{
                              'tw-items-center': runnerEntry?.Scratch,
                              'tw-justify-items-center': runnerEntry?.Scratch
                            }"
                            class="
                              bet
                              tw-flex
                              tw-w-auto
                              tw-content-center
                            "
                          >
                            @if (runnerEntry?.Scratch) {
                              @for (
                                leg of convertLegRange(
                                  selectedPool?.Legs,
                                  selectedPool?.PoolRaces,
                                  selectedPool?.PoolId,
                                  selectedPool,
                                  selectedModifier
                                );
                                track $index
                              ) {
                                <span
                                  [ngClass]="{
                                    'tw-w-[20px]': runnerEntry?.Scratch
                                  }"
                                  class="
                                    scratch
                                    tw-uppercase
                                    tw-font-bold
                                    tw-text-[12px]
                                    tw-mr-[15px]
                                    tw-ml-[15px]
                                  "
                                  [attr.data-cy]="'runner-scratch-' + runner.RunnerId"
                                >
                                  {{ 'ui.wager.scr' | translate: 'scr' }}
                                </span>
                              }
                            }

                            @if (!runnerEntry?.Scratch) {
                              @for (
                                leg of convertLegRange(
                                  selectedPool?.Legs,
                                  selectedPool?.PoolRaces,
                                  selectedPool?.PoolId,
                                  selectedPool,
                                  selectedModifier
                                );
                                track $index
                              ) {
                                <i
                                  (click)="betRace(
                                    $event,
                                    selectedPool?.PoolId || '',
                                    runner?.RunnerId,
                                    0,
                                    leg
                                  )"
                                  class="
                                    runner-{{runner?.RunnerId}}
                                    leg-{{leg}}
                                    tw-block
                                    tw-w-[26px]
                                    tw-h-[26px]
                                    tw-self-center
                                    tw-text-center
                                    tw-not-italic
                                    tw-rounded-[15px]
                                    tw-text-[#FFFFFF]
                                    tw-mr-[12px]
                                    tw-ml-[12px]
                                  "
                                  [ngClass]="{'sub-couple-entry': i > 0}"
                                  [attr.data-cy]="'select-runner-' + leg + '-' + runner.RunnerId"
                                  [attr.data-entry-id]="runnerEntry?.EntryId"
                                  id="{{leg}}"
                                ></i>
                              }
                            }
                          </div>

                          <!-- $1 Pays after the bet legs (hidden for GSL/DBL/PK) -->
                          @if (!hidePays) {
                            <div class="pays tw-w-[60px] tw-py-[5px]">
                              <p
                                class="tw-text-center"
                                [class.tw-line-through]="runnerEntry?.Scratch"
                                [attr.data-cy]="'runner-pay-' + runner.RunnerId + '-' + i"
                              >
                                {{
                                  (runnerEntry?.Scratch) ?
                                    '-'
                                      :
                                    !selectedRace.Current ?
                                      '-'
                                        :
                                      ((matrix || null) | matrixData: indexRunner: 'onePays') || '-'
                                }}
                              </p>
                            </div>
                            <!-- Stake + Payout per runner (single-leg, single-race pools only) -->
                            @if (!hideStake) {
                              <div class="stake tw-w-[60px] tw-py-[5px]">
                                <p
                                  class="tw-text-center"
                                  [class.tw-line-through]="runnerEntry?.Scratch"
                                  [attr.data-cy]="'runner-stake-' + runner.RunnerId + '-' + i"
                                >
                                  {{ runnerEntry?.Scratch ? '-' : getRunnerStake(runner.RunnerId) }}
                                </p>
                              </div>
                              <!-- Payout = $1 Pays × stake -->
                              <div class="payout tw-w-[60px] tw-py-[5px]">
                                <p
                                  class="tw-text-center"
                                  [class.tw-line-through]="runnerEntry?.Scratch"
                                  [attr.data-cy]="'runner-payout-' + runner.RunnerId + '-' + i"
                                >
                                  {{
                                    (runnerEntry?.Scratch || !selectedRace.Current)
                                      ? '-'
                                      : getRunnerPayout(runner.RunnerId, indexRunner)
                                  }}
                                </p>
                              </div>
                            }
                          }
                        </div>

                        <!-- Info tab: jockey / trainer / weight for this entry -->
                        @if (controller.info && !runnerEntry?.Scratch) {
                          <div
                            class="
                              runner-extra-info
                              tw-flex
                              tw-flex-wrap
                              tw-gap-x-[28px]
                              tw-gap-y-[2px]
                              tw-bg-[#C5D9EF]
                              tw-text-[#19385D]
                              tw-text-[14px]
                              tw-px-[12px]
                              tw-py-[6px]
                              tw-border-[#7C8FCC]
                              tw-border-r-[1px]
                              tw-border-l-[1px]
                              tw-border-b-[1px]
                            "
                            [attr.data-cy]="'runner-info-details-' + runner.RunnerId + '-' + i"
                          >
                            <span [attr.data-cy]="'runner-jockey-' + runner.RunnerId">
                              <span class="tw-font-bold">{{ runnerRoleLabel }}:</span> {{ runnerEntry?.Jockey }}
                            </span>
                            <span [attr.data-cy]="'runner-trainer-' + runner.RunnerId">
                              <span class="tw-font-bold">{{ 'wager.trainer' | translate: 'Trainer:' }}</span> {{ runnerEntry?.Trainer }}
                            </span>
                            @if (!isHarnessTrack) {
                              <span [attr.data-cy]="'runner-weight-' + runner.RunnerId">
                                <span class="tw-font-bold">{{ 'wager.weight' | translate: 'Weight:' }}</span> {{ runnerEntry?.Weight }}
                              </span>
                            }
                          </div>
                        }

                        @if (runnerWithReplays.length > 0) {
                          <div class="tw-flex tw-flex-col">
                            <div class="tw-flex">
                              <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-ml-[5px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                                {{ 'STABLE_SYSTEM.TRACKNAME' | translate: 'TrackName' }}
                              </div>
                              <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                                {{ 'STABLE_SYSTEM.RACEDAY' | translate: 'RaceDay' }}
                              </div>
                              <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                                {{ 'generic.breed' | translate: 'Breed' }}
                              </div>
                              <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                                {{ 'generic.race' | translate: 'Race' }}
                              </div>
                              <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                                {{ 'STABLE_SYSTEM.DISTANCE' | translate: 'Distance' }}
                              </div>
                              <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                                {{ 'STABLE_SYSTEM.SURFACE' | translate: 'Surface' }}
                              </div>
                              <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                                {{ 'generic.purse' | translate: 'Purse' }}
                              </div>
                              <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-mr-[5px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                              </div>
                            </div>

                            @for (
                              replay
                              of runnerWithReplays[indexRunner]?.entries[i]?.availableReplays.slice(
                                0, 5
                              );
                              track $index
                            ) {
                              <div
                                class="
                                  replay-row
                                  tw-flex
                                  tw-border-[#19385D]
                                  tw-border-b-[1px]
                                  tw-ml-[5px]
                                "
                              >
                                <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                  {{ replay.track }}
                                </div>
                                <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                  {{ replay?.date | dateFormat: 'MM-DD-YYYY' }}
                                </div>
                                <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                  {{ replay?.breed }}
                                </div>
                                <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                  {{ replay?.race }}
                                </div>
                                <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                  {{ replay?.distance }}
                                </div>
                                <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                  {{ replay?.surface }}
                                </div>
                                <div class="tw-flex-1 tw-text-center tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                  {{ '$' + (replay?.purse | numberWithCommas: 0) }}
                                </div>
                                <div class="tw-content-center tw-py-[2px] tw-px-[8px] tw-flex-1">
                                  <button
                                    (click)="getReplayVideo(replay)"
                                    class="
                                      tw-uppercase
                                      tw-text-[15px]
                                      tw-bg-[#19385D]
                                      tw-text-[#FFFFFF]
                                      tw-px-[16px]
                                      tw-py-[4px]
                                      tw-rounded-[20px]
                                      tw-hover:bg-[#102940]
                                      tw-transition-colors
                                    "
                                  >
                                    {{ 'STABLE_SYSTEM.WATCH' | translate: 'watch' }}
                                  </button>
                                </div>
                              </div>
                            }
                          </div>
                        }

                        @if (isLoadingReplays) {
                          <div class="tw-relative tw-w-full">
                            <mat-spinner
                              diameter="30"
                              class="
                                tw-top-[-5px]
                                tw-mt-[8px]
                                tw-mr-auto
                                tw-ml-auto
                              "
                            >
                            </mat-spinner>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }

                <!-- Footer (single-race "All" per leg) -->
                <div
                  [ngClass]="{'empty-pool': selectedPool === undefined}"
                  class="swipe-container tw-w-auto"
                  data-cy="legs-container"
                >
                  <!-- Left-aligned to mirror the body columns so each "All" sits under its bet column -->
                  <div class="mode-place-races tw-flex tw-pl-[10px]">
                    <!-- Spacer for the leading Runner + Elo + ML + Odds + position columns -->
                    <span class="tw-w-[538px] tw-shrink-0" aria-hidden="true"></span>
                    @for (
                      leg of convertLegRange(
                        selectedPool?.Legs,
                        selectedPool?.PoolRaces,
                        selectedPool?.PoolId,
                        selectedPool,
                        selectedModifier
                      );
                      track $index
                    ) {
                      <div
                        class="
                          head-bet
                          tw-w-[51px]
                          tw-shrink-0
                          tw-text-center
                          tw-py-[10px]
                        "
                      >
                        <span
                          (click)="betAllRace($event, leg)"
                          id="{{leg}}"
                          class="
                            mode
                            selector-leg-all-{{leg}}
                            tw-w-[40px]
                            tw-inline-block
                            tw-bg-[#FF6F6F]
                            tw-text-[#FFFFFF]
                            tw-rounded-[4px]
                            tw-cursor-pointer
                            tw-text-[12px]
                            tw-py-[5px]
                          "
                          data-cy="wager-all"
                        >
                          {{ 'generic.all' | translate: 'All' }}
                        </span>
                      </div>
                    }
                  </div>
                </div>

              }
            </div>
          </div>
        }

        <!-- BODY: Pick / DBL multi-race pools (driven by dblPkLegsView) -->
        @if (dblPkArray) {
          <div class="table-runner runners-section">
            <div class="content-runner dbl-pk-content">

              @for (
                legView of dblPkLegsView;
                let indexRunner = $index;
                track trackByLegView(indexRunner, legView)
              ) {
                <div
                  [id]="legView.isActiveHidden ? 'runner-info-empty' : null"
                  [hidden]="legView.isFullyHidden"
                  class="!tw-block runner-info {{ legView.idClass }}"
                  [attr.data-cy]="'runner-info-' + legView.identity?.RunnerId"
                >
                  <div
                    #runnerInfo
                    class="runner-group {{ legView.uiClass }} tw-border-[#7C8FCC]"
                    [attr.data-cy]="
                      'runner-entry-' + legView.identity?.RunnerId +
                      '-' + (legView.identity?.EntryId || 1)
                    "
                  >
                    <div
                      [ngClass]="{
                        'tw-border-t-[1px]': runnerWithReplays.length > 0,
                        'tw-h-[35px]': !legView.identity?.Name
                      }"
                      class="
                        tw-w-[100%]
                        tw-h-[100%]
                        tw-flex
                        tw-border-[#7C8FCC]
                        tw-border-r-[1px]
                        tw-border-l-[1px]
                        tw-border-b-[1px]
                        tw-pl-[10px]
                      "
                    >
                      <!-- Name (from active race) -->
                      <div class="runner tw-w-[278px] tw-py-[5px]">
                        @if (!legView.isActiveHidden && !legView.identity?.isReplica) {
                          <div class="tw-flex tw-items-center">
                            <p class="tw-inline-block">
                              <span
                                class="entry-name"
                                [class.tw-line-through]="legView.identity?.Scratch"
                                [attr.data-cy]="'runner-name-' + legView.identity?.RunnerId"
                              >
                                {{ legView.identity?.Name }}
                              </span>
                            </p>
                          </div>
                        }
                      </div>

                      <!-- Elo (for the active race) -->
                      <div class="elo tw-w-[51px] tw-py-[5px]">
                        @if (!legView.isActiveHidden && !legView.identity?.isReplica) {
                          <p
                            class="tw-text-center tw-italic"
                            [attr.data-cy]="'runner-elo-' + legView.identity?.RunnerId"
                          >
                            {{
                              legView.identity?.Scratch
                                ? '-'
                                : getRunnerElo(
                                    legView.activeRaceId,
                                    legView.identity?.RunnerId,
                                    legView.identity?.EntryId
                                  )
                            }}
                          </p>
                        }
                      </div>

                      <!-- ML (morning line from parent Runner, preserved via groupRunnerEntries) -->
                      <div class="ml tw-w-[51px] tw-py-[5px]">
                        @if (!legView.isActiveHidden && !legView.identity?.isReplica) {
                          <p
                            class="tw-text-center"
                            [attr.data-cy]="'runner-ml-' + legView.identity?.RunnerId"
                          >
                            {{
                              legView.identity?.Scratch
                                ? '-'
                                : (legView.identity?.Odds || '-')
                            }}
                          </p>
                        }
                      </div>

                      <!-- Live Odds (only when active race === selectedRace, since matrix is per-race) -->
                      <div class="odds tw-w-[51px] tw-py-[5px]">
                        @if (!legView.isActiveHidden && !legView.identity?.isReplica) {
                          <p
                            class="tw-text-center"
                            [class.tw-line-through]="legView.identity?.Scratch"
                            [attr.data-cy]="'runner-odds-' + legView.identity?.RunnerId"
                          >
                            {{
                              legView.identity?.Scratch
                                ? 'SCR'
                                : (legView.useMatrix && legView.runnerIndex >= 0 && selectedRace?.Current
                                    ? (((matrix || null) | matrixData: legView.runnerIndex: 'odd') || '-')
                                    : '-')
                            }}
                          </p>
                        }
                      </div>

                      <!-- Saddle / position (from active race) -->
                      <div
                        class="pos tw-w-[110px]"
                        [attr.data-cy]="'runner-position-' + legView.identity?.RunnerId"
                      >
                        <div class="tw-w-[65%]"></div>
                        <div
                          class="
                            tw-w-[35%]
                            tw-h-full
                            tw-relative
                            tw-text-center
                            tw-self-center
                            tw-items-center
                            tw-px-[5px]
                            {{
                              !legView.isActiveHidden && !legView.identity?.isReplica
                                ? ((selectedEvent?.ToteResponse?.EventDetail?.TrackType | getTrackType: true)
                                    + '-' + legView.identity?.RunnerId)
                                : ''
                            }}
                          "
                        >
                          <div class="tw-h-full tw-content-center">
                            @if (!legView.isActiveHidden && !legView.identity?.isReplica) {
                              {{
                                legView.identity?.EntryId
                                  ? legView.identity?.RunnerId + legView.identity?.EntryId
                                  : legView.identity?.RunnerId
                              }}
                            }
                          </div>
                          <!-- Post position badge, only when it differs from the saddle number -->
                          @if (
                            !legView.isActiveHidden && !legView.identity?.isReplica
                            && (legView.identity?.Position | toNumber) !== legView.identity?.RunnerId
                          ) {
                            <span
                              class="tw-text-[9px] tw-absolute tw-top-[2px] tw-right-[3px]"
                              [attr.data-cy]="'runner-post-' + legView.identity?.RunnerId"
                            >
                              {{ legView.identity?.Position }}
                            </span>
                          }
                        </div>
                      </div>

                      <!-- One bet cell per race, from precomputed cells[raceIndex] -->
                      @for (
                        race of dblPkArray;
                        let raceIndex = $index;
                        track trackByRaceId(raceIndex, race)
                      ) {
                        <!-- Hovering a bet cell switches to that race, like the R# header. -->
                        <div
                          (mouseenter)="showCurrentInfoByRace(race.RaceId, raceIndex)"
                          [ngClass]="{
                            'tw-w-[51px]':
                              legView.cells[raceIndex]?.Scratch ||
                              legView.cells[raceIndex]?.toHide,
                            'tw-items-center':
                              legView.cells[raceIndex]?.Scratch,
                            'tw-justify-items-center':
                              legView.cells[raceIndex]?.Scratch
                          }"
                          class="bet tw-content-center"
                        >
                          @if (legView.cells[raceIndex]?.Scratch) {
                            <span
                              class="
                                scratch
                                tw-w-[38px]
                                tw-uppercase
                                tw-font-bold
                                tw-text-[12px]
                                tw-text-center
                                tw-block
                              "
                            >
                              {{ 'ui.wager.scr' | translate: 'scr' }}
                            </span>
                          }

                          @if (
                            legView.cells[raceIndex] &&
                            !legView.cells[raceIndex].Scratch &&
                            !legView.cells[raceIndex].toHide &&
                            !legView.cells[raceIndex].isReplica
                          ) {
                            <i
                              (click)="betRace(
                                $event,
                                selectedPool?.PoolId || '',
                                legView.cells[raceIndex].RunnerId,
                                legView.cells[raceIndex].RaceId,
                                legView.cells[raceIndex].RaceId
                              )"
                              class="
                                runner-{{ legView.cells[raceIndex].RunnerId }}
                                leg-{{ legView.cells[raceIndex].RaceId }}
                                tw-block
                                tw-w-[26px]
                                tw-h-[26px]
                                tw-self-center
                                tw-text-center
                                tw-not-italic
                                tw-rounded-[15px]
                                tw-text-[#FFFFFF]
                                tw-mr-[12px]
                                tw-ml-[12px]
                              "
                              [ngClass]="{
                                'sub-couple-entry': !!legView.cells[raceIndex].EntryId
                              }"
                              [attr.data-cy]="
                                'select-runner-' +
                                legView.cells[raceIndex].RaceId + '-' +
                                legView.cells[raceIndex].RunnerId
                              "
                              [attr.data-entry-id]="legView.cells[raceIndex].EntryId"
                              [attr.data-index-is]="indexRunner"
                              id="{{ legView.cells[raceIndex].RaceId }}"
                            ></i>
                          }
                        </div>
                      }

                      <!-- $1 Pays after the bet legs (hidden for GSL/DBL/PK) -->
                      @if (!hidePays) {
                        <div class="pays tw-w-[60px] tw-py-[5px]">
                          @if (!legView.isActiveHidden && !legView.identity?.isReplica) {
                            <p
                              class="tw-text-center"
                              [class.tw-line-through]="legView.identity?.Scratch"
                              [attr.data-cy]="'runner-pay-' + legView.identity?.RunnerId"
                            >
                              {{
                                legView.identity?.Scratch
                                  ? '-'
                                  : (legView.useMatrix && legView.runnerIndex >= 0 && selectedRace?.Current
                                      ? (((matrix || null) | matrixData: legView.runnerIndex: 'onePays') || '-')
                                      : '-')
                              }}
                            </p>
                          }
                        </div>
                        <!-- Stake + Payout per runner (single-leg, single-race pools only) -->
                        @if (!hideStake) {
                          <div class="stake tw-w-[60px] tw-py-[5px]">
                            @if (!legView.isActiveHidden && !legView.identity?.isReplica) {
                              <p
                                class="tw-text-center"
                                [class.tw-line-through]="legView.identity?.Scratch"
                                [attr.data-cy]="'runner-stake-' + legView.identity?.RunnerId"
                              >
                                {{ legView.identity?.Scratch ? '-' : getRunnerStake(legView.identity?.RunnerId) }}
                              </p>
                            }
                          </div>
                          <!-- Payout = $1 Pays × stake -->
                          <div class="payout tw-w-[60px] tw-py-[5px]">
                            @if (!legView.isActiveHidden && !legView.identity?.isReplica) {
                              <p
                                class="tw-text-center"
                                [class.tw-line-through]="legView.identity?.Scratch"
                                [attr.data-cy]="'runner-payout-' + legView.identity?.RunnerId"
                              >
                                {{
                                  legView.identity?.Scratch
                                    ? '-'
                                    : (legView.useMatrix && legView.runnerIndex >= 0 && selectedRace?.Current
                                        ? getRunnerPayout(legView.identity?.RunnerId, legView.runnerIndex)
                                        : '-')
                                }}
                              </p>
                            }
                          </div>
                        }
                      }
                    </div>

                    <!-- Info tab: jockey / trainer / weight for this entry -->
                    @if (
                      controller.info
                      && !legView.isActiveHidden
                      && !legView.identity?.isReplica
                      && !legView.identity?.Scratch
                    ) {
                      <div
                        class="
                          runner-extra-info
                          tw-flex
                          tw-flex-wrap
                          tw-gap-x-[28px]
                          tw-gap-y-[2px]
                          tw-bg-[#C5D9EF]
                          tw-text-[#19385D]
                          tw-text-[14px]
                          tw-px-[12px]
                          tw-py-[6px]
                          tw-border-[#7C8FCC]
                          tw-border-r-[1px]
                          tw-border-l-[1px]
                          tw-border-b-[1px]
                        "
                        [attr.data-cy]="'runner-info-details-' + legView.identity?.RunnerId"
                      >
                        <span [attr.data-cy]="'runner-jockey-' + legView.identity?.RunnerId">
                          <span class="tw-font-bold">{{ runnerRoleLabel }}:</span> {{ legView.identity?.Jockey }}
                        </span>
                        <span [attr.data-cy]="'runner-trainer-' + legView.identity?.RunnerId">
                          <span class="tw-font-bold">{{ 'wager.trainer' | translate: 'Trainer:' }}</span> {{ legView.identity?.Trainer }}
                        </span>
                        @if (!isHarnessTrack) {
                          <span [attr.data-cy]="'runner-weight-' + legView.identity?.RunnerId">
                            <span class="tw-font-bold">{{ 'wager.weight' | translate: 'Weight:' }}</span> {{ legView.identity?.Weight }}
                          </span>
                        }
                      </div>
                    }

                    <!-- Replays (only when this row has at least one visible entry) -->
                    @if (!legView.isFullyHidden) {
                      @if (runnerWithReplays.length > 0) {
                        <div class="tw-flex tw-flex-col">
                          <div class="tw-flex">
                            <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-ml-[5px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                              {{ 'STABLE_SYSTEM.TRACKNAME' | translate: 'TrackName' }}
                            </div>
                            <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                              {{ 'STABLE_SYSTEM.RACEDAY' | translate: 'RaceDay' }}
                            </div>
                            <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                              {{ 'generic.breed' | translate: 'Breed' }}
                            </div>
                            <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                              {{ 'generic.race' | translate: 'Race' }}
                            </div>
                            <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                              {{ 'STABLE_SYSTEM.DISTANCE' | translate: 'Distance' }}
                            </div>
                            <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                              {{ 'STABLE_SYSTEM.SURFACE' | translate: 'Surface' }}
                            </div>
                            <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                              {{ 'generic.purse' | translate: 'Purse' }}
                            </div>
                            <div class="tw-bg-[#19385D] tw-text-[#FFFFFF] tw-mt-[6px] tw-mr-[5px] tw-py-[1px] tw-px-[4px] tw-flex-1">
                            </div>
                          </div>

                          @for (replay of getReplaysFor(legView); track $index) {
                            <div
                              class="
                                replay-row
                                tw-flex
                                tw-border-[#19385D]
                                tw-border-b-[1px]
                                tw-ml-[5px]
                              "
                            >
                              <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                {{ replay.track }}
                              </div>
                              <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                {{ replay?.date | dateFormat: 'MM-DD-YYYY' }}
                              </div>
                              <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                {{ replay?.breed }}
                              </div>
                              <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                {{ replay?.race }}
                              </div>
                              <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                {{ replay?.distance }}
                              </div>
                              <div class="tw-flex-1 tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                {{ replay?.surface }}
                              </div>
                              <div class="tw-flex-1 tw-text-center tw-overflow-x-hidden tw-overflow-y-auto tw-h-[40px] tw-p-2">
                                {{ '$' + (replay?.purse | numberWithCommas: 0) }}
                              </div>
                              <div class="tw-content-center tw-py-[2px] tw-px-[8px] tw-flex-1">
                                <button
                                  (click)="getReplayVideo(replay)"
                                  class="
                                    tw-uppercase
                                    tw-text-[15px]
                                    tw-bg-[#19385D]
                                    tw-text-[#FFFFFF]
                                    tw-px-[16px]
                                    tw-py-[4px]
                                    tw-rounded-[20px]
                                    tw-hover:bg-[#102940]
                                    tw-transition-colors
                                  "
                                >
                                  {{ 'STABLE_SYSTEM.WATCH' | translate: 'watch' }}
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      }

                      @if (isLoadingReplays) {
                        <div class="tw-relative tw-w-full">
                          <mat-spinner
                            diameter="30"
                            class="
                              tw-top-[-5px]
                              tw-mt-[8px]
                              tw-mr-auto
                              tw-ml-auto
                            "
                          >
                          </mat-spinner>
                        </div>
                      }
                    }
                  </div>
                </div>
              }

              <!-- Footer: "All" per race, left-aligned to mirror the body columns so each "All" sits under its bet column -->
              <div class="mode-place-races tw-flex tw-pl-[10px]">
                <!-- Spacer for the leading Runner + Elo + ML + Odds + position columns -->
                <span class="tw-w-[538px] tw-shrink-0" aria-hidden="true"></span>
                @for (item of dblPkArray; track trackByRaceId($index, item)) {
                  <div
                    class="
                      head-bet
                      tw-w-[51px]
                      tw-shrink-0
                      tw-text-center
                      tw-py-[10px]
                    "
                  >
                    @if (item.RaceId) {
                      <span
                        (click)="betAllRace($event, item.RaceId)"
                        id="{{ item.RaceId }}"
                        class="
                          mode
                          selector-leg-all-{{ item.RaceId }}
                          tw-w-[40px]
                          tw-inline-block
                          tw-bg-[#FF6F6F]
                          tw-text-[#FFFFFF]
                          tw-rounded-[4px]
                          tw-cursor-pointer
                          tw-text-[12px]
                          tw-py-[5px]
                        "
                        data-cy="wager-all"
                      >
                        {{ 'generic.all' | translate: 'All' }}
                      </span>
                    }
                  </div>
                }
              </div>

            </div>
          </div>
        }

      </div>
    </div>

  </div>
</div>
